
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/content_wall/templates/moment_end_of_content"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<header class='column_header'></header>\n<div class='posts_container'><div class='end_of_content_title'>End of Content</div></div>\n";
},"useData":true});
    }).call(this);
  